import { useQuery } from "@tanstack/react-query";
import { postRequest } from "../api/client";

/**
 * POST body for `POST /surveillance/overview/charts/events` (matches gateway + curl `--data-raw`).
 */
export type OverviewChartsEventsBody = {
  from: string;
  to: string;
  location_id: string[];
  cameraIds: string[];
  clientId: string;
  withClientDetails: {
    role: string[];
    creatorId: string;
    id: string;
  };
  Events?: string[];
  Status?: string[];
  Slots?: string[];
};

const EVENTS_PATH = "/surveillance/overview/charts/events";

/** Stable query key so identity changes on identical payloads do not churn the cache. */
function chartsEventsQueryKey(body: OverviewChartsEventsBody) {
  return [
    EVENTS_PATH,
    body.from,
    body.to,
    JSON.stringify([...body.location_id].sort()),
    JSON.stringify([...body.cameraIds].sort()),
    body.clientId,
    JSON.stringify(body.withClientDetails),
    body.Events?.length ? JSON.stringify([...body.Events].sort()) : null,
    body.Status?.length ? JSON.stringify([...body.Status].sort()) : null,
    body.Slots?.length ? JSON.stringify([...body.Slots].sort()) : null,
  ] as const;
}

/**
 * React Query wrapper for POST {@link EVENTS_PATH} with JSON body (same as curl).
 */
export function useOverviewChartsEvents(body: OverviewChartsEventsBody | null, enabled: boolean) {
  return useQuery({
    queryKey: body ? chartsEventsQueryKey(body) : [EVENTS_PATH, "disabled"],
    queryFn: () => postRequest<unknown>(EVENTS_PATH, body!),
    enabled: Boolean(enabled && body?.clientId && body.location_id.length > 0),
  });
}
